module.exports = __webpack_public_path__ + "static/media/Fcc.820ad1ec.png";